import styled from 'styled-components';
import { Modal } from '$quantum/atoms/ModalDeprecated';
import { inputCss } from '$components/basic/Autocomplete/components/SearchInput/styled';
import { vars } from '$util/theme';

export const Styled = styled.div`
  ${inputCss}
`;

export const ModalStyled = styled(Modal)`
  &.ant-modal {
    .ant-modal-body {
      overflow: hidden;
      padding: 0;
      max-height: none;
    }
  }
  .Autocomplete {
    .SearchInput {
      border-bottom: 1px solid ${vars.quantumverse.reskinColors.neutral200};
      .ant-input-affix-wrapper {
        border: none;
        border-radius: 0;
        padding-left: 0%;
      }
      .ant-input-group-addon {
        border: none;
        padding: 0 5px 0 10px;
        > .back-button:first-child {
          display: block;
          height: auto;
          padding: 10px;
          background: none;
          box-shadow: none;
        }
      }
    }
    .SuggestionsContainer {
      border: none;
      border-radius: 0;
      margin-top: 0;
      max-height: 100vh;
      max-height: calc(100vh - 61px);
    }
  }
`;
